import React from 'react';
import PropTypes from 'prop-types';

import logoImage from '../../assets/images/TELUS-logo-white.gif';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const Footer = ({ disclaimer = true }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    FOOTER: { DISCLAIMER_MESSAGE, COPYRIGHT_MESSAGE }
  } = localizedStrings;

  const copyrightYear = new Date().getFullYear();

  return (
    <>
      {disclaimer && (
        <div id="disclaimer" align="center">
          {DISCLAIMER_MESSAGE}
        </div>
      )}
      <div id="footer" align="center">
        <img src={logoImage} title="TELUS" alt="Telus logo" />
        <p>
          &copy; {copyrightYear} {COPYRIGHT_MESSAGE}
        </p>
      </div>
    </>
  );
};

Footer.propTypes = {
  disclaimer: PropTypes.bool
};

export default Footer;
